import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from '@/router/index';
import store from '@/store/index';
import Directive from '@/utils/loadmore';
import i18n from '@/i18n';
import ElementUI from 'element-gui';
import lodash from 'lodash';
import 'element-gui/lib/theme-chalk/index.css';
import './styles/public.css';
import './styles/common.scss';
import './assets/styles/element-variables.scss';
import './assets/styles/new-ui.scss';
import util from '@/utils/util';
import {Base64} from 'js-base64'

Vue.prototype.$Base64 = Base64;

Vue.config.devtools = true;
Vue.prototype.$bus = new Vue();

Vue.use(ElementUI);

Object.defineProperty(Vue.prototype, '$lodash', {
  value: lodash,
});

// loadmore
Vue.config.productionTip = false;
Vue.use(Directive);

// 定位滚动头部
router.afterEach(() => {
  window.scrollTo(0, 0);
});

// 路由拦截
router.beforeEach((to, from, next) => {
  next();
});

// layer 通过静态 import 引用，打包时由 webpack 处理
import layer from '@/dialog/layer';
import '@/dialog/theme/default/layer.css';

Vue.prototype.$layer = layer;


const vm = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
